import DealerUserEditForm from '../dealer-users/components/DealerUserEditForm';
import { DealerBranch } from '../dealer-branches/dealerBranch';
import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  Permissions,
  dealerUserService,
} from '../dealer-users/dealerUserService';
import DealerUserChangePasswordModal from '../dealer-users/components/DealerUserChangePasswordModal';
import { NotificationManager } from 'react-notifications';
import { DealerBranchFilter } from '../dealer-branches/dealerBranchFilter';
import { PageLoadingSpinner } from '@ami/react/core';
import PropTypes from 'prop-types';

class DealerUserEditPageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permissions: new Permissions(),
      availableEmailTemplateTypes: [],
      submitting: false,
      sendingInvitation: false,
    };

    this.onDealerUserChanged = this.onDealerUserChanged.bind(this);
    this.save = this.save.bind(this);
    this.navigateBack = this.navigateBack.bind(this);
    this.retireUser = this.retireUser.bind(this);
    this.changePasswordModalRef = React.createRef();
  }
  static defaultProps = {
    enabledAddDealerGroup: true,
    enabledRemoveDealerGroup: true,
  };

  static propTypes = {
    dealerUser: PropTypes.object.isRequired,
    saveFunc: PropTypes.func.isRequired,
    getDealerUserFunc: PropTypes.func.isRequired,
    handleDealerUserChanged: PropTypes.func.isRequired,
    enabledAddDealerGroup: PropTypes.bool,
    enabledRemoveDealerGroup: PropTypes.bool,
  };

  getDealerBranches = async (dealerGroupId) => {
    this.setState({
      dealerBranches: await DealerBranch.search(
        new DealerBranchFilter({
          dealerGroupId: dealerGroupId,
          includeRetired: true,
        })
      ),
    });
  };

  getPermissions() {
    dealerUserService.getAllPermissions().then((permissions) => {
      permissions = permissions || { dealerBranch: [] };
      this.setState({ permissions });
    });
  }

  getAvailableEmailTemplateTypes() {
    dealerUserService
      .getAvailableEmailTemplateTypes()
      .then((availableEmailTemplateTypes) => {
        this.props.dealerUser.enabledEmailTemplateTypes =
          availableEmailTemplateTypes.map((x) => x.type);
        this.setState({ availableEmailTemplateTypes });
      });
  }

  async componentDidMount() {
    this.getPermissions();
    this.getAvailableEmailTemplateTypes();
  }

  save() {
    this.setState({ submitting: true });
    this.props
      .saveFunc()
      .then(this.navigateBack)
      .catch(() => this.setState({ submitting: false }));
  }

  retireUser() {
    const { dealerUser } = this.props;
    dealerUserService.retireUser(dealerUser.userId).then(this.navigateBack);
  }

  navigateBack = () => {
    this.setState({ canceling: true }, () => {
      this.props.history.push('/dealer-users');
    });
  };

  openChangePasswordModal = () => {
    this.changePasswordModalRef.current.open();
  };

  sendInvitationEmail = () => {
    const { dealerUser } = this.props;
    this.setState({ sendingInvitation: true });
    dealerUserService
      .sendInvitationEmail(dealerUser.userId)
      .then(async () => {
        NotificationManager.success(
          'Invitation email sent successfully',
          '',
          3 * 1000
        );
        this.props.getDealerUserFunc();
      })
      .catch(() => console.log('An error ocurred sending the invitation email'))
      .finally(() => this.setState({ sendingInvitation: false }));
  };

  async onDealerUserChanged(dealerUser) {
    this.props.handleDealerUserChanged(dealerUser);
  }

  render() {
    const {
      permissions,
      availableEmailTemplateTypes,
      submitting,
      canceling,
      sendingInvitation,
    } = this.state;

    const { dealerUser, enabledAddDealerGroup, enabledRemoveDealerGroup } =
      this.props;

    if (!dealerUser) {
      return <PageLoadingSpinner />;
    }
    return (
      <div>
        <DealerUserEditForm
          areThereAnyChanges={!submitting && !canceling}
          dealerUser={dealerUser}
          permissions={permissions}
          availableEmailTemplateTypes={availableEmailTemplateTypes}
          onSubmit={this.save}
          onCancel={this.navigateBack}
          onDelete={this.retireUser}
          deleteEnabled={true}
          dealerUserChanged={this.onDealerUserChanged}
          submitting={submitting}
          openChangePasswordModal={this.openChangePasswordModal}
          sendingInvitation={sendingInvitation}
          sendInvitationEmail={this.sendInvitationEmail}
          enabledAddDealerGroup={enabledAddDealerGroup}
          enabledRemoveDealerGroup={enabledRemoveDealerGroup}
        />
        {dealerUser.isRegistered && (
          <DealerUserChangePasswordModal
            ref={this.changePasswordModalRef}
            userId={dealerUser.userId}
          />
        )}
      </div>
    );
  }
}

const DealerUserEditPage = withRouter(DealerUserEditPageComponent);
export { DealerUserEditPage };
